import MostAmazingConnectImage from '../assets/the-most-amazing-way-to-connect.svg';

type Meta = {
	title: string;
	image: string;
	action: string;
	detail: string;
	mobileDetail: string;
	buttonTitle: string;
};

export type BasicProfile = { andTag: string; firstName: string | null, profilePicUrl: string | null };

export const getMeta = (
	basicProfile: BasicProfile,
	searchParams: URLSearchParams,
	actionOverride?: string
): Meta | null => {
	const action = actionOverride || searchParams.get('a');

	if (!action) {
		return null;
	}

	const { andTag, firstName } = basicProfile;

	const firstNameOrAndTag =
		firstName && firstName !== 'is' ? firstName : `&${andTag}`;

	const title = '&' + andTag;
	let detail = `Scan to connect with ${firstNameOrAndTag}, then complete the steps on your phone.`;
	let mobileDetail = `To complete your connection to ${firstNameOrAndTag}, get the & app.`;
	let buttonTitle = `Connect with ${firstNameOrAndTag}`;
	let image;

	switch (action) {
		case 'cl':
			detail = 'Scan then complete the steps on your phone to claim your &.';
			mobileDetail = 'To claim your &, get the & app.';
			break;
		case 'iv': {
			const inviterFirstName = searchParams.get('fn');
			const inviterAndTag = searchParams.get('at');
			const subject = inviterFirstName ? `${inviterFirstName} (&${inviterAndTag})` : `&${inviterAndTag}`;
			detail = mobileDetail = `${subject} held this &tag for you - a universal handle that will be yours across EVERY platform`;
			image = MostAmazingConnectImage;
			buttonTitle = 'Get App + Claim It';
			break;
		}
		case 'co':
			if (window.location.pathname.includes('ref')) {
				detail = mobileDetail = `${firstNameOrAndTag} wants to connect with you on &.`;
				buttonTitle = 'Accept';
				image = basicProfile.profilePicUrl;
			}
			break;
		default:
			break;
	}

	return { action, image, title, detail, mobileDetail, buttonTitle };
};